export enum UserTypes {
	ANONYMOUS = 'anonymous',
	ORG_MEMBER = 'org-member',
	CONFLUENCE_USER = 'confluence-user',
	ATLASSIAN_USER = 'atlassian-user',
}
